// extracted by mini-css-extract-plugin
export default {"loader":"IPEX2026Pg_loader__gkrWd","kiosPg":"IPEX2026Pg_kiosPg__QZjLp","cardsRow":"IPEX2026Pg_cardsRow__sMpFW","scheduleButton":"IPEX2026Pg_scheduleButton__n0OEz"};